import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-transfer',
  templateUrl: './home-transfer.component.html',
  styleUrls: ['./home-transfer.component.css']
})
export class HomeTransferComponent implements OnInit {

  role:number = 3;

  constructor() { }

  ngOnInit() {
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/transfer/components/home-transfer/home-transfer.component.ts